export default "__VITE_ASSET__ZpNH23Fz__"